module.exports = __webpack_public_path__ + "img/phonetic_dict.a02d64a9.png";